import { uiConstants } from '../../../../constants'
import Box from '../../../UI/Box/Box'

import css from './Boxes.module.scss'

const Boxes = () => {
  return (
    <div className={css.Container}>
      <ul className={css.UlBox}>
        {uiConstants.boxes.map((b, key) => (
          <li key={key}>
            <Box {...b} />
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Boxes
